/**
 * ContactChatPage (KAN-736)
 *
 * /clients/:clientId/chat: the conversation of one client on a full page
 * inside DashboardLayout ("Широкий вид" of the conversation modal opens it in
 * a new tab). Same body as the modal (ContactConversationPanel), loaded by the
 * clientId from the URL: title and manual mode from the client card, the
 * estimate from his latest estimate with messages.
 * KAN-815/816: the next bot touch of the client is shown by the shared body
 * (ContactConversationPanel), so the modal and the page show it alike.
 */
import { Loader2 } from 'lucide-react'
import { useParams } from 'react-router-dom'
import { ContactConversationPanel } from '@/components/contact/ContactConversationPanel'
import { useClientConversationTarget } from '@/components/clients/useClientConversationTarget'

export function ContactChatPage() {
  const { clientId = null } = useParams<{ clientId: string }>()
  const target = useClientConversationTarget({ clientId })

  if (target.isClientLoading) {
    return (
      <div className="flex items-center justify-center py-12 text-gray-500">
        <Loader2 className="mr-2 h-5 w-5 animate-spin" aria-hidden="true" />
        Загрузка…
      </div>
    )
  }

  if (!clientId || target.isClientError || !target.client) {
    return (
      <p className="py-12 text-center text-sm text-gray-500" role="status">
        Клиент не найден
      </p>
    )
  }

  return (
    <div
      className="flex h-full min-h-0 min-w-0 flex-col rounded-lg border border-gray-200 bg-white p-3 sm:p-6"
      data-testid="contact-chat-page"
    >
      <ContactConversationPanel
        contactId={target.contactId}
        title={target.title}
        clientId={clientId}
        manualMode={target.client.manual_mode}
        active
      />
    </div>
  )
}
